import { selectCurrency, selectPartnerId } from 'legacy/lut/features/partner360/configuration'
import { ChangeEvent, useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { Translation, useSafetyTranslation } from 'cng-common/features/translations'
import { P360Currency } from 'partner360/models/P360Currency'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../configs/translations'
import { useMdfAnalysis } from '../../hooks/useMdfAnalysis'
import { getMdfBreakdownGroups } from '../../lib'
import { TMdfBreakdownGroupField } from '../../model/types'
import { MdfBreakdownChart } from '../mdfBreakdownChart'

import { getGroupFieldOptions } from './helpers/getGroupFieldOptions'

import styles from './MdfActivitiesBreakdownChart.module.scss'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS.dashboard.breakdown

const groupFieldOptions = getGroupFieldOptions()

export const MdfActivitiesBreakdownChart = () => {
  const t = useSafetyTranslation()
  const partnerId = useSelector(selectPartnerId)
  const { filteredActivities: activities } = useMdfAnalysis(partnerId)
  const activeCurrency = useSelector(selectCurrency)
  const isUsd = activeCurrency === P360Currency.USD

  const [groupField, setGroupField] = useState<TMdfBreakdownGroupField>(groupFieldOptions[0].value)

  const groups = useMemo(
    () => getMdfBreakdownGroups(activities, groupField, isUsd),
    [activities, groupField, isUsd]
  )

  const handleGroupFieldChange = useCallback((event: ChangeEvent<HTMLSelectElement>) => {
    setGroupField(event.target.value as TMdfBreakdownGroupField)
  }, [])

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.titleBlock}>
          <h3 className={styles.title}>
            <Translation text={KEYS.title} span />
          </h3>
          <div className={styles.subtitle}>
            <Translation text={KEYS.subtitle} span />
          </div>
        </div>

        <select className={styles.groupSelect} value={groupField} onChange={handleGroupFieldChange}>
          {groupFieldOptions.map((groupFieldOption) => (
            <option key={groupFieldOption.value} value={groupFieldOption.value}>
              {t(groupFieldOption.labelKey)}
            </option>
          ))}
        </select>
      </div>

      <MdfBreakdownChart groups={groups} isUsd={isUsd} />
    </div>
  )
}

MdfActivitiesBreakdownChart.displayName = 'MdfActivitiesBreakdownChart'
